import React from 'react';
import { withRouter } from 'react-router-dom';
import { Pagination } from 'module-tsl-ui-pagination';
import qs from 'query-string';

const clickedPaginationLink = (evt, push, pathname, queryString) => {
  const parseCurrentSearch = qs.parse(queryString);
  const searchQs = {...parseCurrentSearch, currentpage: evt};
  const search = qs.stringify(searchQs);

  push({
    pathname,
    search
  });
};

const PaginationComponent = ({ metadata: { pagination }, history: { push }, base: {pathname, qs: queryString}}) => {
  const { currentpage, totalpages } = pagination;

  return (
    <Pagination
      currentPage={currentpage}
      numberOfPages={totalpages}
      onChangePage={evt => {
        clickedPaginationLink(evt, push, pathname, queryString);
      }}
    />
  );
};

export default withRouter(PaginationComponent);
